import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { selectUser } from "../../store/userSlice";
import UserWidgetContainer from "../utils/UserWidgetContainer";
import { ToastContainer, toast } from "react-toastify";

import heroBackgroundImage from "tenant/background_video_first_frame.png";
import heroBackgroundVideo from "tenant/background_video.mp4";
import heroBackgroundImageMobile from "tenant/background_video_mobile_first_frame.png";
import heroBackgroundVideoMobile from "tenant/background_video_mobile.mp4";

import logoImage from "tenant/logo.svg";
import "../../styles/components/layout/HeroCardLayout.css";

interface HeroCardLayoutProps {
  children: React.ReactNode;
  showCard?: boolean;
  cardClassName?: string;
  suppressLogout?: boolean;
  errorMessage?: string;
}

type Alert = { type: "error"; errorMessage: string };

const HeroCardLayout: React.FC<HeroCardLayoutProps> = ({
  children,
  showCard = true,
  cardClassName = "",
  suppressLogout = false,
  errorMessage = null,
}) => {
  const reduxUser = useSelector(selectUser);
  const [displayErrorMessage, setDisplayErrorMessage] = useState<string | null>(null);

  useEffect(() => {

    try {
      const stored = sessionStorage.getItem("postLogoutAlert");
      if (stored) {
        const parsed = JSON.parse(stored) as Alert;
        setDisplayErrorMessage(parsed.errorMessage);
        sessionStorage.removeItem("postLogoutAlert"); // clear after reading
      }
    } catch {
      setDisplayErrorMessage(null);
    }

    let actualErrorMessage = errorMessage ?? displayErrorMessage;

    // We're not really using toasts in the normal way here:
    // we're really just using them as error messages. We should
    // instead display errors inline in the card. A future battle.
    if (actualErrorMessage) {
      toast.error(actualErrorMessage, {
        position: "top-right",
        hideProgressBar: true,
        closeOnClick: false,
        autoClose: false,
        draggable: false,
        closeButton: true,
        toastId: 1,
      });
    } else {
      toast.dismiss(1);
    }
  }, [errorMessage, displayErrorMessage]);

  return (
    <div className="hero-layout">
      <div className="hero-bg-container">
        <img src={heroBackgroundImage} alt="Video Placeholder" className="hero-bg-media" />
        <video className="hero-bg-media  hero-bg-desktop" src={heroBackgroundVideo} autoPlay muted loop playsInline />

        <img src={heroBackgroundImageMobile} alt="Video Placeholder" className="hero-bg-media hero-bg-mobile" />
        <video className="hero-bg-media hero-bg-mobile" src={heroBackgroundVideoMobile} autoPlay muted loop playsInline />

      </div>

      {/* Persona logo in top-left */}
      <div className="hero-logo-container">
        <img src={logoImage} alt="Persona" />
      </div>

      {/* Logout button */}
      {reduxUser && !suppressLogout && (
        <UserWidgetContainer/>
      )}

      {/* Content - either in a card or full layout */}
      {showCard ? (
        <div className={`hero-card ${cardClassName}`}>
          <div className="hero-card-content">{children}</div>
        </div>
      ) : (
        children
      )}

      <ToastContainer />
    </div>
  );
};

const HeroCardOnlyComponent: React.FC = () => {
  return (
    <HeroCardLayout>
      <div>Some Content 1</div>
      <div>Some Content 2</div>
      <div>Some Content 3</div>
    </HeroCardLayout>
  );
};

export default HeroCardLayout;
export { HeroCardOnlyComponent };
